"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactRedux = require("react-redux");
var _cccisdReduxFormHelpers = require("cccisd-redux-form-helpers");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var OrgQuestLimit = function OrgQuestLimit(props) {
  var _useState = (0, _react.useState)(props.operation === 'edit'),
    _useState2 = _slicedToArray(_useState, 2),
    edit = _useState2[0],
    setEdit = _useState2[1];
  var type = props.displaySettings.fieldProps.type;
  var label = {
    respondent: 'Respondent',
    sms: 'SMS'
  };
  (0, _react.useEffect)(function () {
    if (!props.level) {
      return;
    }
    var levels = {
      respondent: {
        Basic: '5000',
        Premium: '20000',
        Unlimited: ''
      },
      sms: {
        Basic: '0',
        Premium: '1200',
        Unlimited: ''
      }
    };
    props.field.onChange(edit ? props.field.initialValue : levels[type][props.level]);
    setEdit(false);
  }, [props.level]);
  return /*#__PURE__*/_react["default"].createElement(_cccisdReduxFormHelpers.FieldBlock, {
    field: props.field,
    label: "".concat(label[type], " Limit")
  }, /*#__PURE__*/_react["default"].createElement("input", _extends({
    className: "form-control"
  }, (0, _cccisdReduxFormHelpers.domOnlyProps)(props.field), {
    placeholder: "Unlimited"
  })));
};
var mapStateToProps = function mapStateToProps(state) {
  var _state$form, _state$form$DynamicFo, _state$form$DynamicFo2;
  return {
    level: (_state$form = state.form) === null || _state$form === void 0 ? void 0 : (_state$form$DynamicFo = _state$form.DynamicForm) === null || _state$form$DynamicFo === void 0 ? void 0 : (_state$form$DynamicFo2 = _state$form$DynamicFo.level) === null || _state$form$DynamicFo2 === void 0 ? void 0 : _state$form$DynamicFo2.value
  };
};
var _default = exports["default"] = (0, _reactRedux.connect)(mapStateToProps, {})(OrgQuestLimit);